if (!customElements.get('dhs-card-variants')) {
  customElements.define('dhs-card-variants', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      const select = this.querySelector('select');
      const button = this.querySelector('button');
      const card = this.closest('.dhs-collection-card');
      const update = () => {
        const option = select.selectedOptions[0];
        const available = option?.dataset.available === 'true';
        button.disabled = !available;
        button.textContent = !select.value ? 'Choose options' : available ? 'Add to cart' : 'Out of stock';
        if (!select.value) return;
        card.querySelector('.dhs-collection-card__price').textContent = option.dataset.price;
        const slot = card.querySelector('[data-dhs-card-unit-slot]');
        if (slot) {
          slot.replaceChildren();
          const count = Number(option.dataset.unitCount), name = option.dataset.unitName;
          const units = ['pair','towel','bottle','tube','kit','bar','pillow','mat','item'];
          if (option.dataset.unitEnabled === 'true' && Number.isInteger(count) && count > 1 && units.includes(name)) {
            const row = document.createElement('div'); row.className = 'dhs-pack-unit-price dhs-pack-unit-price--card'; row.dataset.dhsCardUnitPrice = '';
            const strong = document.createElement('strong');
            strong.textContent = new Intl.NumberFormat('en-AU', {style:'currency',currency:'AUD'}).format(Number(option.dataset.priceCents)/100/count) + ' AUD / ' + name;
            const small = document.createElement('small'); small.textContent = count + ' ' + name + 's per pack';
            row.append(strong, small); slot.append(row);
          }
        }
        const stock = card.querySelector('.dhs-collection-card__stock');
        if (stock) { stock.textContent = available ? 'In stock' : 'Out of stock';
        stock.classList.toggle('is-out', !available);
        stock.setAttribute('aria-live', 'polite'); }
        card.querySelectorAll('.dhs-collection-card__title, .dhs-collection-card__media').forEach(link => { link.href = option.dataset.url; });
      };
      select.addEventListener('change', update);
      update();
    }
  });
}
